import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function fmtErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Guest id (localStorage) so anonymous scores can be tracked per device.
export function guestId() {
  let id = localStorage.getItem("popless_guest_id");
  if (!id) {
    id = "g_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("popless_guest_id", id);
  }
  return id;
}
